export default __webpack_public_path__ + "static/gt-haptik-medium-500.latin-c7cc14b05cf0dd03f38795c39834caf9.woff2";